import { Component, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { LazyLoadEvent } from 'primeng';
import { CountriesService } from '../../../../../services/countries.service';
import { RefferalDiscountService } from '../../../../../services/refferal-discount.service';
import { DoctorBreadcrumbService } from '../../../shared/breadcrumb.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

interface UpdateBody {
    is_active: boolean;
    starts_at: Date;
    expires_at: Date;
}

interface DiscountFilterQuery {
    page_no: number;
    records_per_page: number;
    from_date: Date;
    to_date: Date;
    country_id: number;
    is_active: boolean;
    discount_code: string;
    discount_percent: number;
}
interface statusList {
    name: string;
    value: boolean;
}
interface country {
    id: number;
    country_name: string;
}

@TraceClassDecorator()
@Component({
    selector: 'app-egd-coupons',
    templateUrl: './egd-coupons.component.html',
    styleUrls: ['./egd-coupons.component.css', '../../../../../../assets/css/custom-egd.css']
})
export class EgdCouponsComponent implements OnInit {
    display: boolean = false;
    discountCodeList: [];
    counter = 1;
    dob: Date;
    dob1: any;
    is_active: boolean = false;
    updateBody: UpdateBody = {
        is_active: false,
        starts_at: undefined,
        expires_at: undefined
    };
    discount_id;
    e: any;
    loading: boolean = false;
    totalRecords: number;
    first: number = 0;
    loading1: boolean = false;
    query: DiscountFilterQuery = {
        page_no: 1,
        records_per_page: 10,
        from_date: null,
        to_date: null,
        country_id: null,
        is_active: null,
        discount_code: null,
        discount_percent: null
    };
    posting: boolean = false;
    refferaltypesList = [];
    countriesList: any[] = [];
    statusList: statusList[];
    countriesListTemp: any[] = [];
    discountCodeString: string = null;
    discountPercentNumber: number = null;
    provider_id: string = "";
    slug: string = "";
    is_active_status: statusList = {
        name: 'All',
        value: null
    };
    selectedCountry = {
        id: null,
        country_name: 'All'
    };
    disabledDates: boolean = true;
    discountCode;
    expDate: Date;
    stDate: Date;
    ue: string = null;

    constructor(
        private readonly refferalDiscountService: RefferalDiscountService,
        private readonly CountryService: CountriesService,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly providerStateService : ProviderStateService
    ) {
        
        this.statusList = [
            { name: 'All', value: null },
            { name: 'Active', value: true },
            { name: 'Deactive', value: false }
        ];

        // this.getCountries();
        // this.countriesList.push({ id :0 , country_name :"Global"});
        // this.countriesList=[
        //     { id :0 , country_name :"Global"}
        // ]
        // this.countriesList.push(this.countriesListTemp);
    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Admin' },
            { label: 'Discount Coupons' }
        ]);
        this.provider_id = this.providerStateService.getProviderId();
        await this.getCountries();
        await this.loadDiscountCode(null);
    }
    async Reset()
    {
        this.query = {
            page_no: 1,
            records_per_page: 10,
            from_date: null,
            to_date: null,
            country_id: null,
            is_active: null,
            discount_code: null,
            discount_percent: null
        };
        this.loadDiscountCode(null);
    }
    async loadDiscountCode(event: LazyLoadEvent) {
        if (event != null) {
            this.query.page_no = event.first / event.rows + 1;
            this.query.records_per_page = event.rows;
        }
        this.loading1 = true;
        this.e = null
        await this.refferalDiscountService
            .getDicountCodeList(this.query)
            .toPromise()
            .then((resp) => {
                if (resp.success) {
                    this.discountCodeList = resp.data.data.rows;
                    this.totalRecords = resp.data.data.count;
                    this.loading1 = false;
                } else {
                    this.posting = false;
                    this.loading = false;
                    this.discountCodeList = [];
                    this.e = resp.error.message;
                    this.loading1 = false;
                }
            })
            .catch((resp) => {

                this.e = resp.error.message;
                this.loading1 = false;
            });

    }

    private async getCountries() {
        await this.CountryService.getCountries(this.provider_id)
            .toPromise()
            .then((countries) => {
                // this.countriesList =[{id :0 , country_name :"Global"}];



                this.countriesListTemp.push({
                    id: null,
                    country_name: 'All',
                    acronym: '',
                    is_supported: true,
                    phone_code: 234,
                    image_url: null,
                    currency_type: 'NGN',
                    currency_symbol: null,
                    rate_usd: '421.927',
                    is_national_license: true,
                    created_at: '2021-05-02T06:58:19.636Z',
                    updated_at: '2021-10-14T01:00:01.600Z'
                });
                this.countriesListTemp.push({
                    id: 0,
                    country_name: 'Global',
                    acronym: '',
                    is_supported: true,
                    phone_code: 234,
                    image_url: null,
                    currency_type: 'NGN',
                    currency_symbol: null,
                    rate_usd: '421.927',
                    is_national_license: true,
                    created_at: '2021-05-02T06:58:19.636Z',
                    updated_at: '2021-10-14T01:00:01.600Z'
                });
                this.countriesListTemp = this.countriesListTemp.concat(countries);
                
                this.countriesList = this.countriesListTemp;
            });
    }

    Submit() {
        this.query.is_active = this.is_active_status.value;
        this.query.country_id = this.selectedCountry.id;
        if (this.disabledDates) {
            this.query.from_date = null;
            this.query.to_date = null;
        }
        if (this.discountCodeString?.length != 0) {
            this.query.discount_code = this.discountCodeString;
        } else {
            this.query.discount_code = null;
        }
        if (this.discountPercentNumber > 0) {
            this.query.discount_percent = this.discountPercentNumber;
        } else {
            this.query.discount_percent = null;
        }
        this.loadDiscountCode(null);
    }

    showDialog(discountCode) {
        this.ue = null;
        this.is_active = discountCode.is_active;
        this.expDate = new Date(discountCode.expires_at); //discountCode.expires_at.substring(0,10);
        this.stDate = new Date(discountCode.starts_at);
        this.discount_id = discountCode.discount_id;
        this.display = true;
    }

    updateDiscountCode() {
        this.loading = true;
        this.ue = null;
        this.updateBody.is_active = this.is_active;
        this.updateBody.starts_at = this.stDate;
        this.updateBody.expires_at = this.expDate;
        this.updateDicount();
    }
    async updateDicount() {
        await this.refferalDiscountService
            .updateDicountCode(this.discount_id, this.updateBody)
            .toPromise()
            .then((resp) => {
                if (resp.success) {
                    this.loading = false;
                    this.ue = 'Discount Code Updated Successfully';
                    this.loadDiscountCode(null);
                } else {
                    this.loading = false;
                    this.ue = 'error : ' + resp.error.message;
                }
            })
            .catch((error) => {
                this.e = error.error.message;
            });
    }
}
